// extracted by mini-css-extract-plugin
module.exports = {"circle":"NetworkDisplay_circle__CLdhx","active":"NetworkDisplay_active__ODWxB","wrong":"NetworkDisplay_wrong__2-Kx4"};